import axios from "axios";
import { serverApi } from "../../../config/Keys";
import {
  CLEAR_ERRORS,
  CLEAR_LOADER,
  SET_LOADER,
  SET_LOADER_SECONDARY,
  SET_REQUESTED_PROMOTION,
  UPDATED_REQUESTED_PROMOTION,
  SET_MAINTAIN_PROMOTION,
  UPDATED_MAINTAIN_PROMOTION,
  SET_VALIDATE_PROMOTION,
  UPDATED_VALIDATE_PROMOTION,
  SET_APPROVED_PROMOTION,
  UPDATED_APPROVED_PROMOTION,
} from "../../types";
import { setErrors } from "../errorActions";
import Alert from "react-s-alert";

/*************************************************
 * @DESC ADD ACTION FOR MERCHANT PROMOTION & aSSIGN TAGS
 ************************************************/
/****************** ADD REQUEST MERCHANT PROMOTION ********************/
export const admin_add_merchant_promotion =
  (token, formData, onSuccess) => async (dispatch) => {
    try {
      dispatch({ type: CLEAR_ERRORS });
      dispatch({ type: SET_LOADER_SECONDARY });
      let response = await axios.post(
        `${serverApi}/merchant-permotion`,
        formData,
        {
          headers: {
            Authorization: token,
            "Content-Type": "application/json",
          },
        }
      );
      if (response.status === 201) {
        if (response.data?.status === 401) {
          Alert.error(`<h4>${response.data?.message}</h4>`, {
            position: "top-right",
            effect: "bouncyflip",
            beep: true,
            html: true,
            timeout: 5000,
            offset: 35,
          });
        } else {
          onSuccess();
        }
        dispatch({ type: CLEAR_LOADER });
      }
    } catch (err) {
      Alert.error(
        `<h4>${
          err?.response?.message ||
          err?.response?.data?.message ||
          "Please enter correct details."
        }</h4>`,
        {
          position: "top-right",
          effect: "bouncyflip",
          beep: true,
          html: true,
          timeout: 5000,
          offset: 35,
        }
      );
      dispatch({ type: CLEAR_LOADER });
      dispatch(setErrors(err));
    }
  };

/****************** ADD ASSIGN MERCHANT TAGS ********************/
export const admin_assign_merchant_promotion_tag =
  (token, formData, onSuccess) => async (dispatch) => {
    try {
      dispatch({ type: CLEAR_ERRORS });
      dispatch({ type: SET_LOADER_SECONDARY });
      let response = await axios.post(`${serverApi}/uom-ratio`, formData, {
        headers: {
          Authorization: token,
          "Content-Type": "application/json",
        },
      });
      if (response.status === 201) {
        onSuccess();
        dispatch({ type: CLEAR_LOADER });
      }
    } catch (err) {
      Alert.error(
        `<h4>${err?.response?.message || "Please enter correct details."}</h4>`,
        {
          position: "top-right",
          effect: "bouncyflip",
          beep: true,
          html: true,
          timeout: 5000,
          offset: 35,
        }
      );
      dispatch({ type: CLEAR_LOADER });
      dispatch(setErrors(err));
    }
  };

/*************************************************
 * @DESC GET ACTION FOR MERCHANT PROMOTION
 ************************************************/
/****************** GET REQUEST MERCHANT PROMOTION ********************/
export const admin_get_requested_merchant_promotion =
  (
    token,
    currentPageNo,
    nextPageNo,
    actionPerform,
    dateQuery,
    onSuccess,
    requestType,
    requestTypeFilter,
    requestedTag,
    promotionType,
    requestedTagFilter,
    promotionTypeFilter
  ) =>
  async (dispatch) => {
    try {
      dispatch({ type: CLEAR_ERRORS });
      // dispatch({ type: SET_LOADER_SECONDARY });
      let response = await axios.get(
        `${serverApi}/merchant-permotion?&page=${currentPageNo}&limit=${nextPageNo}${
          actionPerform
            ? ""
            : `&startDate=${dateQuery?.startDate}&endDate=${
                dateQuery?.endDate
              }${requestType ? `&filterBY1=${requestTypeFilter}` : ""}${
                requestedTag ? `&filterBY2=${requestedTagFilter}` : ""
              }${
                promotionType
                  ? `&filterBY3=${promotionTypeFilter.toString()}`
                  : ""
              }`
        }`,
        {
          headers: {
            Authorization: token,
            "Content-Type": "application/json",
          },
        }
      );
      if (response.status === 200) {
        dispatch({ type: SET_REQUESTED_PROMOTION, payload: response.data });
        onSuccess();
        dispatch({ type: CLEAR_LOADER });
      }
    } catch (err) {
      Alert.error(
        `<h4>${
          err?.response?.data?.message ||
          err?.response?.data ||
          err?.response?.message ||
          "Please enter correct details."
        }</h4>`,
        {
          position: "top-right",
          effect: "bouncyflip",
          beep: true,
          html: true,
          timeout: 5000,
          offset: 35,
        }
      );
      dispatch({ type: CLEAR_LOADER });
      dispatch(setErrors(err));
    }
  };

/*************************************************
 * @DESC EDIT ACTION
 ************************************************/
/****************** UPDATE REQUEST MERCHANT PROMOTION ********************/
export const admin_update_requested_merchant_promotion =
  (token, formData, onEditSuccess, onError) => async (dispatch) => {
    try {
      dispatch({ type: CLEAR_ERRORS });
      dispatch({ type: SET_LOADER_SECONDARY });
      let response = await axios.put(
        `${serverApi}/merchant-permotion`,
        formData,
        {
          headers: {
            Authorization: token,
            "Content-Type": "application/json",
          },
        }
      );
      if (response.status === 200) {
        onEditSuccess();
        dispatch({ type: CLEAR_LOADER });
      }
    } catch (err) {
      if (onError) onError();
      Alert.error(
        `<h4>${
          err?.response?.data?.message ||
          err?.response?.data ||
          "Please enter correct details."
        }</h4>`,
        {
          position: "top-right",
          effect: "bouncyflip",
          beep: true,
          html: true,
          timeout: 5000,
          offset: 35,
        }
      );
      dispatch({ type: CLEAR_LOADER });
      dispatch(setErrors(err));
    }
  };

export const admin_update_promotion_status =
  (token, formData, promotionId, onEditSuccess) => async (dispatch) => {
    try {
      dispatch({ type: CLEAR_ERRORS });
      dispatch({ type: SET_LOADER_SECONDARY });
      let response = await axios.patch(
        `${serverApi}/merchant-permotion/${promotionId}`,
        formData,
        {
          headers: {
            Authorization: token,
            "Content-Type": "application/json",
          },
        }
      );
      if (response.status === 200) {
        onEditSuccess();
        dispatch({ type: CLEAR_LOADER });
      }
    } catch (err) {
      Alert.error(
        `<h4>${
          err?.response?.data?.message ||
          err?.response?.data ||
          "Please enter correct details."
        }</h4>`,
        {
          position: "top-right",
          effect: "bouncyflip",
          beep: true,
          html: true,
          timeout: 5000,
          offset: 35,
        }
      );
      dispatch({ type: CLEAR_LOADER });
      dispatch(setErrors(err));
    }
  };

export const admin_update_toggle_promotion =
  (token, formData, toggleValue, onEditSuccess) => async (dispatch) => {
    try {
      dispatch({ type: CLEAR_ERRORS });
      dispatch({ type: SET_LOADER_SECONDARY });
      let response = await axios.put(
        `${serverApi}/merchant-permotion?updateToggle=${toggleValue}`,
        formData,
        {
          headers: {
            Authorization: token,
            "Content-Type": "application/json",
          },
        }
      );
      if (response.status === 200) {
        onEditSuccess();
        dispatch({ type: CLEAR_LOADER });
      }
    } catch (err) {
      Alert.error(
        `<h4>${
          err?.response?.data?.message ||
          err?.response?.data ||
          "Please enter correct details."
        }</h4>`,
        {
          position: "top-right",
          effect: "bouncyflip",
          beep: true,
          html: true,
          timeout: 5000,
          offset: 35,
        }
      );
      dispatch({ type: CLEAR_LOADER });
      dispatch(setErrors(err));
    }
  };

/*************************************************
 * @DESC DELETE ACTION
 ************************************************/
/****************** DELETE REQUEST MERCHANT PROMOTION ********************/
export const admin_delete_requested_promotion =
  (token, promationId, onSuccessDelete) => async (dispatch) => {
    try {
      dispatch({ type: CLEAR_ERRORS });
      dispatch({ type: SET_LOADER });
      let response = await axios.delete(
        `${serverApi}/merchant-permotion/${promationId}`,
        {
          headers: {
            Authorization: token,
            "Content-Type": "application/json",
          },
        }
      );
      if (response.status === 200) {
        onSuccessDelete();
        dispatch({ type: CLEAR_LOADER });
      }
    } catch (err) {
      dispatch({ type: CLEAR_LOADER });
      dispatch(setErrors(err));
    }
  };
